import { Spinner } from 'components'
import { useAuthStatus } from 'hooks'
import { Navigate, Outlet } from 'react-router-dom'

const PrivateRoute = () => {
  const { loggedIn, checkingStatus } = useAuthStatus()

  if (checkingStatus) {
    return <Spinner />
  }
  return loggedIn ? <Outlet /> : <Navigate to='/' />
}

export default PrivateRoute
